import React from 'react';

const BreakTimeHighlight = ({ children }) => (
  <span style={{ fontWeight: 'bold' }}>{children}</span>
);

export default BreakTimeHighlight;
